import type { HighlightConfig } from './types';

/**
 * Default configuration for the highlight service
 */
export const DEFAULT_CONFIG: Required<HighlightConfig> = {
  autoCleanupTimeout: 30000, // 30 seconds
  debug: false,
  maxSimultaneous: 5,
  throwOnError: false
};

/**
 * Window event name for review progress
 */
export const REVIEW_PROGRESS_EVENT = 'review-progress-update';

/**
 * Log prefix for consistent logging
 */
export const LOG_PREFIX = '[DocumentHighlightService]';

